import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { NotificationDrawerComponent } from './notification-drawer.component';
import { NotificationPanelComponent } from './notification-panel/notification-panel.component';

@NgModule({
    declarations: [NotificationPanelComponent, NotificationDrawerComponent],
    imports: [
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [NotificationPanelComponent, NotificationDrawerComponent],
})
export class NotificationDrawerModule {}
